import { INBOX_SCOPE_OWNED, INBOX_SCOPE_INVITED } from '../utils/inbox'

export const CHAT_STATUS_IDLE = 'idle'
export const CHAT_STATUS_LOADING = 'loading'
export const CHAT_STATUS_READY = 'ready'
export const CHAT_STATUS_UNAVAILABLE = 'unavailable'
export const CHAT_STATUS_FORBIDDEN = 'forbidden'
export const CHAT_STATUS_ERROR = 'error'

export const createInboxState = () => ({
  ids: [],
  page: 0,
  hasMore: false,
  loading: false,
  loaded: false,
  error: false,
})

export const createMessagesState = () => ({
  items: [],
  loaded: false,
  loading: false,
  loadingOlder: false,
  hasMoreOlder: false,
  error: false,
})

export const createInitialState = () => ({
  status: CHAT_STATUS_IDLE,
  connectionStatus: 'idle',
  activeScope: INBOX_SCOPE_OWNED,
  inbox: {
    [INBOX_SCOPE_OWNED]: createInboxState(),
    [INBOX_SCOPE_INVITED]: createInboxState(),
  },
  // ConversationResponse por conversationId (lastMessage também é atualizado pelo WS)
  conversations: {},
  openConversationId: null,
  // A tela do chat está montada e a aba do navegador visível
  viewVisible: false,
  // Estado da timeline por conversationId (ver createMessagesState)
  messages: {},
  // Último seq enviado em /read por mim, por conversa
  myReadSeq: {},
  // Último seq lido pelo cliente vindo do WS (read.updated); combinado com
  // ConversationResponse.customerLastReadSeq no getter OPEN_MESSAGES_STATE
  customerReadSeq: {},
  // { [conversationId]: { displayName, until } }
  typing: {},
})
